import React, { useEffect } from 'react';
import { EspaceAtna } from '../components/espace/EspaceAtna';
import { ForYouFeed } from '../components/espace/ForYouFeed';
import { LocalNews, NearbyEvents, UsefulServices } from '../components/espace/LocalContent';
import { AppPromo } from '../components/espace/AppPromo';
import { citizenFirstName } from '../data/espace';
import { useEspace } from '../contexts/EspaceContext';
export function MonEspace() {
  const {
    enterEspace
  } = useEspace();
  useEffect(() => {
    enterEspace();
  }, [enterEspace]);
  return <main className="min-h-screen bg-white" data-id="element-2086" data-mp="12900q8qhboqr">
      <div className="px-5 py-10 lg:px-10" data-id="element-2087" data-mp="nc9aoq2p3pdt">
        <header data-id="element-2088" data-mp="nbfz9bsskbpc">
          <h1 className="text-3xl font-extrabold tracking-tight text-ville-navy lg:text-4xl" data-id="element-2089" data-mp="nbzkb1dqng7l">
            Hello {citizenFirstName}
          </h1>
          <p className="mt-1 text-[17px] text-slate-600" data-id="element-2090" data-mp="382qbrnb3vwk4">Here is what concerns you today.</p>
        </header>

        <div className="mt-6 max-w-3xl" data-id="element-2091" data-mp="3d1tfn4fcnwqi">
          <EspaceAtna data-id="element-2092" data-mp="3d2ur3a0a2l8r" />
        </div>

        <ForYouFeed data-id="element-2093" data-mp="1axbmxm8bvy18" />
        <LocalNews data-id="element-2094" data-mp="1awtkg7v2onkv" />
        <NearbyEvents data-id="element-2095" data-mp="1ayeelwdh64i7" />
        <UsefulServices data-id="element-2096" data-mp="1azphltz3j889" />
        <AppPromo data-id="element-2097" data-mp="15yic61kfel4r" />
      </div>
    </main>;
}